module.exports = __webpack_public_path__ + "img/viz-bar--1.95a46831.svg";